export interface CompaniesSummaryDto {
  driversTotal: number;
  activeDriversTotal: number;
  activeTrucksTotal: number;
  activeTrucksWithParamsLastWeek: number;
  trucksTotal: number;
}

export interface DrivingPeriodDto {
  driverId: string;
  startedAt: string;
  endedAt: string | null;
  fullName: string;
  isActive: boolean;
}
